import { Result as AntdResult, ResultProps as AntdResultProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface ResultProps extends AntdResultProps {}

export const resultPrefixCls = `${CMP_PREFIX}-result`;

export const Result = ({ ...props }: ResultProps) => {
  return <AntdResult {...props} />;
};
